import { render, staticRenderFns } from "./TradeTable.vue?vue&type=template&id=e5758fce&scoped=true"
import script from "./TradeTable.vue?vue&type=script&lang=js"
export * from "./TradeTable.vue?vue&type=script&lang=js"
import style0 from "./TradeTable.vue?vue&type=style&index=0&id=e5758fce&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5758fce",
  null
  
)

export default component.exports